document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.careers-list[data-section-id]');
  if (!section) {
    return;
  }
  
  const sectionId = section.getAttribute('data-section-id');
  if (!sectionId) {
    return;
  }
  
  initCareersList(section, sectionId);
});

function renderPaginationNumbers(paginationNumbersElement, totalPages, currentPageValue, onPageChange) {
  if (!paginationNumbersElement) {
    return;
  }
  
  paginationNumbersElement.innerHTML = '';
  
  for (let i = 1; i <= totalPages; i++) {
    const pageButton = document.createElement('button');
    pageButton.className = 'careers-list__pagination-number';
    pageButton.textContent = i;
    pageButton.setAttribute('data-page', i);
    
    if (i === currentPageValue) {
      pageButton.classList.add('active');
    }
    
    pageButton.addEventListener('click', () => {
      onPageChange(i);
    });
    
    paginationNumbersElement.appendChild(pageButton);
  }
}

function updatePaginationContainerVisibility(config) {
  const { paginationContainerElement, paginationNumbersElement, totalVisible, itemsPerPage, totalPages, currentPageValue, onPageChangeCallback } = config;
  
  if (!paginationContainerElement) {
    return;
  }
  
  if (totalVisible > itemsPerPage) {
    paginationContainerElement.style.display = 'flex';
    renderPaginationNumbers(paginationNumbersElement, totalPages, currentPageValue, onPageChangeCallback);
  } else {
    paginationContainerElement.style.display = 'none';
  }
}

function updateJobItemsVisibility(allJobItemsArray, visibleJobItems, currentPageValue, itemsPerPage) {
  allJobItemsArray.forEach((item) => {
    if (!item.classList.contains('visible')) {
      item.style.display = 'none';
    }
  });
  
  const startIndex = (currentPageValue - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  
  visibleJobItems.forEach((item, index) => {
    if (index >= startIndex && index < endIndex) {
      item.style.display = 'block';
    } else {
      item.style.display = 'none';
    }
  });
  
  return { startIndex, endIndex };
}

function updateShowingText(config) {
  const { sectionElement, sectionIdValue, startIndex, endIndex, totalVisible } = config;
  const showingElement = sectionElement.querySelector(`#careers-list-showing-${sectionIdValue}`);
  if (showingElement && totalVisible > 0) {
    const start = startIndex + 1;
    const end = Math.min(endIndex, totalVisible);
    const messageTemplate = showingElement.dataset.messageText;
    showingElement.textContent = messageTemplate.replace('{{ start }}', start.toString()).replace('{{ end }}', end.toString()).replace('{{ total }}', totalVisible.toString());
  }
}

function updatePagination(config) {
  const { currentPageValue, allJobItemsArray, itemsPerPage, paginationContainerElement, paginationNumbersElement, sectionElement, sectionIdValue, onPageChangeCallback } = config;
  
  const visibleJobItems = Array.from(allJobItemsArray).filter(item => item.classList.contains('visible'));
  const totalVisible = visibleJobItems.length;
  const totalPages = Math.ceil(totalVisible / itemsPerPage);
  
  updatePaginationContainerVisibility({
    paginationContainerElement,
    paginationNumbersElement,
    totalVisible,
    itemsPerPage,
    totalPages,
    currentPageValue,
    onPageChangeCallback
  });
  
  const { startIndex, endIndex } = updateJobItemsVisibility(
    allJobItemsArray,
    visibleJobItems,
    currentPageValue,
    itemsPerPage
  );
  
  updateShowingText({
    sectionElement,
    sectionIdValue,
    startIndex,
    endIndex,
    totalVisible
  });
}

function applyJobItemFilters(allJobItemsArray, location, department) {
  let visibleCount = 0;

  allJobItemsArray.forEach((item) => {
    const itemArea = item.dataset.jobArea || '';
    const itemDepartment = item.dataset.department || '';

    const locationMatch = !location || location === '' || itemArea === location;
    const departmentMatch = !department || department === '' || itemDepartment === department;
    
    if (locationMatch && departmentMatch) {
      item.classList.add('visible');
      visibleCount++;
    } else {
      item.classList.remove('visible');
    }
  });
  return visibleCount;
}

function updateFilterStats(sectionElement, sectionIdValue, visibleCount) {
  const countElement = sectionElement.querySelector(`#careers-list-count-${sectionIdValue}`);
  if (countElement) {
    countElement.textContent = visibleCount;
  }
}

function handleEmptyState(config) {
  const { emptyMessageElement, itemsContainerElement, paginationContainerElement, sectionElement, sectionIdValue, isEmpty } = config;
  
  if (isEmpty) {
    emptyMessageElement.style.display = 'block';
    itemsContainerElement.style.display = 'none';
    if (paginationContainerElement) {
      paginationContainerElement.style.display = 'none';
    }
    const showingElement = sectionElement.querySelector(`#careers-list-showing-${sectionIdValue}`);
    if (showingElement) {
      showingElement.style.display = 'none';
    }
  } else {
    emptyMessageElement.style.display = 'none';
    itemsContainerElement.style.display = 'flex';
  }
}

function handleCareersFilter(config) {
  const { event, allJobItemsArray, paginationContainerElement, sectionElement, sectionIdValue, emptyMessageElement, itemsContainerElement, currentPageRef, updatePaginationCallback } = config;
  
  const { location, department } = event.detail || {};
  
  const visibleCount = applyJobItemFilters(allJobItemsArray, location, department);
  
  currentPageRef.current = 1;
  
  updateFilterStats(sectionElement, sectionIdValue, visibleCount);
  
  handleEmptyState({
    emptyMessageElement,
    itemsContainerElement,
    paginationContainerElement,
    sectionElement,
    sectionIdValue,
    isEmpty: visibleCount === 0
  });
  
  if (visibleCount > 0) {
    updatePaginationCallback();
  }
}

function initCareersList(section, sectionId) {
  const ITEMS_PER_PAGE = 10;
  
  const itemsContainer = section.querySelector('.careers-list__items');
  const emptyMessage = section.querySelector('.careers-list__empty');
  const allJobItemsNodeList = section.querySelectorAll('.careers-job-item');
  const allJobItems = Array.from(allJobItemsNodeList);
  const paginationContainer = section.querySelector(`#careers-list-pagination-${sectionId}`);
  const paginationNumbers = section.querySelector(`#careers-list-pagination-numbers-${sectionId}`);
  
  if (!itemsContainer || !emptyMessage || allJobItems.length === 0) {
    return;
  }
  
  const currentPageRef = { current: 1 };
  
  function handlePageChange(newPage) {
    currentPageRef.current = newPage;
    updatePagination({
      currentPageValue: currentPageRef.current,
      allJobItemsArray: allJobItems,
      itemsPerPage: ITEMS_PER_PAGE,
      paginationContainerElement: paginationContainer,
      paginationNumbersElement: paginationNumbers,
      sectionElement: section,
      sectionIdValue: sectionId,
      onPageChangeCallback: handlePageChange
    });
  }
  
  function handleFilter(event) {
    handleCareersFilter({
      event: event,
      allJobItemsArray: allJobItems,
      paginationContainerElement: paginationContainer,
      sectionElement: section,
      sectionIdValue: sectionId,
      emptyMessageElement: emptyMessage,
      itemsContainerElement: itemsContainer,
      currentPageRef: currentPageRef,
      updatePaginationCallback: () => {
        updatePagination({
          currentPageValue: currentPageRef.current,
          allJobItemsArray: allJobItems,
          itemsPerPage: ITEMS_PER_PAGE,
          paginationContainerElement: paginationContainer,
          paginationNumbersElement: paginationNumbers,
          sectionElement: section,
          sectionIdValue: sectionId,
          onPageChangeCallback: handlePageChange
        });
      }
    });
  }
  
  // Listen for filter events
  window.addEventListener('careers:filter', handleFilter);
  
  // Show all jobs initially
  allJobItems.forEach(item => item.classList.add('visible'));
  updatePagination({
    currentPageValue: currentPageRef.current,
    allJobItemsArray: allJobItems,
    itemsPerPage: ITEMS_PER_PAGE,
    paginationContainerElement: paginationContainer,
    paginationNumbersElement: paginationNumbers,
    sectionElement: section,
    sectionIdValue: sectionId,
    onPageChangeCallback: handlePageChange
  });

  // Initialize apply modal functionality
  initApplyModal(sectionId);
}

function initApplyModal(sectionId) {
  const modalId = `careers-apply-modal-${sectionId}`;
  const modal = document.getElementById(modalId);
  if (!modal) {
    return;
  }

  const applyButtons = document.querySelectorAll(`.careers-apply-button[aria-controls="${modalId}"]`);

  function setJobNumber(jobNumber, jobTitle) {
    const currentForm = document.querySelector(`.careers-apply-form--${jobNumber}`);
    if (!currentForm) {
      return false;
    }

    const formsEmbed = currentForm.querySelector('shopify-forms-embed');
    if (!formsEmbed?.shadowRoot) {
      return false;
    }

    const submitButton = formsEmbed.shadowRoot.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.style.backgroundColor = 'rgb(49, 13, 13)';
    }

    const input = formsEmbed.shadowRoot.querySelector('input[data-testid="field-custom#job_"]');
    if (!input) {
      return false;
    }

    const jobTitleElement = modal.querySelector('.careers-apply-modal__job-title');
    if (jobTitleElement) {
      jobTitleElement.textContent = jobTitle;
    }

    input.value = jobNumber;
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    
    input.style.display = 'none';
    const container = input.closest('._formFieldContainer_1mxsl_5');
    if (container) {
      container.style.display = 'none';
    }
    
    return true;
  }

  // Retry mechanism to handle Shopify forms app shadow DOM load
  function setJobNumberWithRetry(jobNumber, jobTitle, attempts = 0) {
    displayCurrentForm(jobNumber);
    if (setJobNumber(jobNumber, jobTitle)) {
      return;
    }
    if (attempts < 15) {
      setTimeout(() => setJobNumberWithRetry(jobNumber, jobTitle, attempts + 1), 150);
    }
  }

  applyButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const jobItem = button.closest('.careers-job-item');
      if (!jobItem) {
        return;
      }

      const jobNumber = jobItem.dataset.jobNumber || '';
      const jobTitle = jobItem.dataset.jobTitle || '';
      modal.setAttribute('data-pending-job-number', jobNumber);
      modal.setAttribute('data-pending-job-title', jobTitle);

      if (modal.show) {
        modal.show({ animate: true }).then(() => setJobNumberWithRetry(jobNumber, jobTitle));
      } else {
        modal.setAttribute('open', '');
        setJobNumberWithRetry(jobNumber, jobTitle);
      }
    });
  });

  modal.addEventListener('dialog:after-show', () => {
    const jobNumber = modal.getAttribute('data-pending-job-number');
    const jobTitle = modal.getAttribute('data-pending-job-title');
    if (jobNumber && jobTitle) {
      displayCurrentForm(jobNumber);
      setJobNumberWithRetry(jobNumber, jobTitle);
    }
  });
}

function displayCurrentForm(jobNumber) {
  const form = document.querySelectorAll('.careers-apply-form');

  form.forEach(form => {
    if (form.dataset.jobNumber === jobNumber) {
      form.classList.remove('careers-apply-form-hide');
    } else {
      form.classList.add('careers-apply-form-hide');
    }
  });
}